import {useLocation} from "react-router-dom";
import {dispatchRequestStatus} from "@ots-frontend/ots-data";
import {useTranslation} from "react-i18next";
import {useDispatchRequestMutation,} from "@ots-frontend/ots-ui";
import {DispatchRequestDispatchPage} from "../DispatchRequestDispatchPage/DispatchRequestDispatchPage";

type Props = {
  id?: string;
}

export const DispatchRequestAddDispatchPageRoute = () => {
  const {state} = useLocation();
  const id = state.id;
  return <DispatchRequestAddDispatchPage id={id}/>;
};

export const DispatchRequestAddDispatchPage = (props: Props) => {
  const {id} = props;

  const {t} = useTranslation(["translation"]);

  const {addDispatchToDispatchRequest, isAdding} = useDispatchRequestMutation();

  return (
    <DispatchRequestDispatchPage
      id={id}
      title={t<string>("page.dispatchrequest.adddispatch.title", "Add Dispatch to Dispatch Request")}
      expectedStatus={dispatchRequestStatus.accepted}
      onSubmit={addDispatchToDispatchRequest}
      isSubmitting={isAdding}/>
  );
};
